<template>
  <FeedbackDialog
    :visible="feedback.visible"
    :title="feedback.title"
    :message="feedback.message"
    :type="feedback.type"
    @close="closeFeedback"
  />

  <aside v-if="isMenu === 1" class="sidebar"  :class="{ collapsed: isCollapsed }">
    <div class="logo-box">
      <img src="logo.png" class="logo-img" alt="CreatorsDost Admin">
      <img src="logo_sm.png" class="logo-img-sm" alt="CreatorsDost Admin">
    </div>

    <div class="nav-group-label">Menu</div>
<nav style="height: 100vh!important; overflow-y: auto!important;">

  <!-- DASHBOARD -->
  <div class="nav-item" :class="checkOpt('')" @click="go('')">
    <i class='bx bx-grid-alt'></i>
    <span>Dashboard</span>
  </div>


  <!-- COURSES -->
  <div>

    <div
      class="nav-item"
      :class="checkOpt('courses')"
      @click="toggleMenu('courses')"
    >
      <i class='bx bx-book-open'></i>
      <span>Courses</span>

      <i
        class='bx bx-chevron-down'
        :class="{'bx-rotate-180': activeMenu=='courses'}"
        style="margin-left:auto;"
      ></i>
    </div>

    <div class="sub-menu" v-if="activeMenu=='courses'">

      <div class="sub-item" @click="go('courses')">
        All Courses
      </div>

      <div class="sub-item" @click="go('modules')">
        Modules
      </div>

      <div class="sub-item" @click="go('lectures')">
        Lectures
      </div>

      <div class="sub-item" @click="go('projects')">
        Projects
      </div>

      <div class="sub-item" @click="go('course-faqs')">
        FAQs
      </div>

    </div>

  </div>

  <div
    class="nav-item"
    :class="checkOpt('course-bonuses')"
    @click="go('course-bonuses')"
  >
    <i class='bx bx-gift'></i>
    <span>Course Bonuses</span>
  </div>


  <!-- CATEGORIES -->
  <!-- ORDERS -->
  <div
    class="nav-item"
    :class="checkOpt('orders')"
    @click="go('orders')"
  >
    <i class='bx bx-receipt'></i>
    <span>Orders</span>
  </div>

  <!-- LEARNING PROGRESS -->
  <div
    class="nav-item"
    :class="checkOpt('learning-progress')"
    @click="go('learning-progress')"
  >
    <i class='bx bx-book-reader'></i>
    <span>Learning Progress</span>
  </div>

  <!-- CATEGORIES -->
  <div
    class="nav-item"
    :class="checkOpt('categories')"
    @click="go('categories')"
  >
    <i class='bx bx-category'></i>
    <span>Categories</span>
  </div>


  <!-- MENTORS / CREATORS -->
  <div
    class="nav-item"
    :class="checkOpt('creators')"
    @click="go('creators')"
  >
    <i class='bx bx-user-voice'></i>
    <span>Mentors</span>
  </div>


  <!-- USERS -->
  <div
    class="nav-item"
    :class="checkOpt('users')"
    @click="go('users')"
  >
    <i class='bx bx-group'></i>
    <span>Users</span>
  </div>


  <!-- FEEDBACK / RATINGS -->
  <div
    class="nav-item"
    :class="checkOpt('feedback')"
    @click="go('feedback')"
  >
    <i class='bx bx-star'></i>
    <span>Ratings & Reviews</span>
  </div>


  <!-- SUCCESS STORIES -->
  <div
    class="nav-item"
    :class="checkOpt('stories')"
    @click="go('stories')"
  >
    <i class='bx bx-trophy'></i>
    <span>Success Stories</span>
  </div>


  <!-- BLOG -->
  <div
    class="nav-item"
    :class="checkOpt('blogs')"
    @click="go('blogs')"
  >
    <i class='bx bx-edit'></i>
    <span>Blogs</span>
  </div>


  <!-- CONTENT -->
  <div>

    <div
      class="nav-item"
      :class="checkOpt('content')"
      @click="toggleMenu('content')"
    >
      <i class='bx bx-layout'></i>
      <span>Content</span>

      <i
        class='bx bx-chevron-down'
        :class="{'bx-rotate-180': activeMenu=='content'}"
        style="margin-left:auto;"
      ></i>
    </div>

    <div class="sub-menu" v-if="activeMenu=='content'">

      <div class="sub-item" @click="go('content-main')">
        Main Content
      </div>

      <div class="sub-item" @click="go('content-tiles')">
        Content Tiles
      </div>

      <div class="sub-item" @click="go('engagement')">
        Content Engagement
      </div>

    </div>

  </div>


  <!-- LIVE EVENTS -->
  <!-- NOTE: event table is NOT present in final 15-table DB -->
  <!-- Do NOT add Live Events until event table is added -->


  <!-- ROLES -->
  <!-- <div
    class="nav-item"
    :class="checkOpt('roles')"
    @click="go('roles')"
  >
    <i class='bx bx-shield'></i>
    <span>Roles</span>
  </div> -->

  <div
    class="nav-item"
    :class="checkOpt('admin-settings')"
    @click="go('admin-settings')"
  >
    <i class='bx bx-cog'></i>
    <span>Admin Settings</span>
  </div>


  <!-- ADMIN PROFILE -->
  <!-- <div
    class="nav-item"
    :class="checkOpt('profile')"
    @click="go('profile')"
  >
    <i class='bx bx-user-circle'></i>
    <span>Admin Profile</span>
  </div> -->

</nav>

    <div style="margin-top: auto;">
      <div class="nav-item" @click="openLogoutModal()" style="color: #EF4444;">
        <i class='bx bx-log-out-circle'></i> <span>Logout</span>
      </div>
    </div>
  </aside>

  <section v-if="isMenu === 1" class="main-wrapper">

    <header class="topbar">
      <div class="topbar-left">
        <div class="menu-toggle" @click="handleMenuToggle()">
          <i class='bx bx-menu'></i>
        </div>

        <div class="page-info">
          <h2>Admin Dashboard</h2>
        </div>
      </div>
      <div class="top-right-actions">
        <!-- <div class="action-icon">
          <i class='bx bx-search'></i>
        </div> -->
        <!-- <div class="action-icon" @click="go('notifications')">
          <i class='bx bx-bell'></i>
        </div> -->

        <div v-if="ldata!=null" class="admin-profile">
          <div class="admin-avatar">{{ getFt(ldata.name) }}</div>
          <div class="admin-details">
            <span>{{ ldata.name }}</span>
          </div>
          <i class='bx bx-chevron-down' style="color: var(--text-sub);"></i>
        </div>
      </div>
    </header>

    <main class="viewport">
      <router-view />
    </main>

  </section>

  <div v-else class="login-body">
    <router-view />
 
  </div>
     <!-- LOGOUT CONFIRMATION MODAL -->
<div v-if="showLogoutModal" class="logout-modal-overlay">

  <div class="logout-modal">

    <div class="logout-icon">
      <i class='bx bx-log-out'></i>
    </div>

    <h3>Confirm Logout</h3>
    <p>Are you sure you want to logout from your account?</p>

    <div class="logout-actions">
      <button class="btn-cancel" @click="showLogoutModal = false">
        Cancel
      </button>

      <button class="btn-logout" @click="confirmLogout">
        Logout
      </button>
    </div>

  </div>

</div>
</template>

<script>
  import FeedbackDialog from "@/components/FeedbackDialog.vue";


  export default {
    components: {
      FeedbackDialog,
    },

    data() {
      return {
        isMenu: 0,
        showLogoutModal: false,
        conv: null,
        messages: [],
        activeMenu: "home",
        ldata:null,
        isCollapsed: false,
        feedback: {
          visible: false,
          title: "Notice",
          message: "",
          type: "error",
        },
      };
    },

    mounted() {
      window.addEventListener("admin-feedback", this.handleFeedback);

      const ldataRaw = sessionStorage.getItem('ldata');
      this.ldata = ldataRaw ? JSON.parse(ldataRaw) : null;
      this.isCollapsed = sessionStorage.getItem("isCollapsed")=="true";

      if (this.$route.path=="/login") {
        this.isMenu = 0;
      }
      else {
        this.isMenu = 1;
      }
    },

    beforeUnmount() {
      window.removeEventListener("admin-feedback", this.handleFeedback);
    },

    watch: {
      $route(to) {
        this.isMenu = (to.path === "/login") ? 0 : 1;
      }
    },

    methods: {
      showFeedback(message, title = "Notice", type = "error") {
        this.feedback = {
          visible: true,
          title,
          message: String(message || ""),
          type,
        };
      },

      closeFeedback() {
        this.feedback.visible = false;
      },

      handleFeedback(event) {
        const detail = event?.detail || {};
        this.showFeedback(detail.message, detail.title, detail.type);
      },

       handleMenuToggle() {
        // 📱 Mobile → open sidebar
        if (window.innerWidth <= 768) {
          document.querySelector('.sidebar').classList.toggle('active');
        } 
        // 💻 Desktop → collapse
        else {
          this.isCollapsed = !this.isCollapsed;
          sessionStorage.setItem("isCollapsed",this.isCollapsed+"");
        }
      },

      getFt(fname){
        if(fname.length>2){
           return fname.substring(0,2).toUpperCase();
        }
        return fname.toUpperCase();
      },
      go(p) {
        window.location.href = "/" + p;

      },
      checkOpt(p) {
        if ((p + "").length > 0) {
          return this.$route.path.includes(p) ? 'active' : '';
        }
        else if (this.$route.path === "/") {
          return "active";
        }
      },

      toggleMenu(menu) {
        this.activeMenu = (this.activeMenu === menu) ? '' : menu;
      },
      toggleSidebar() {
        document.querySelector('.sidebar').classList.toggle('active');
      },
      openLogoutModal() {
        this.showLogoutModal = true;
      },

      confirmLogout() {
        sessionStorage.removeItem("ldata");
        sessionStorage.removeItem("accessToken");

        this.showLogoutModal = false;

        this.$router.push("/login");
      }
    }
  };

</script>

<style>
  .login-body {
    height: 100vh;
    width: 100%;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--bg-web);
    /* Subtle geometric background for Web UI */
    background-image: radial-gradient(#cbd5e1 0.5px, transparent 0.5px);
    background-size: 24px 24px;
  }

  .app-layout {
    overflow: hidden;
  }

  /* ===============================
   FLOATING CHAT BUTTON
   =============================== */

  .chat-fab {
    position: fixed;
    right: 24px;
    bottom: 24px;
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: #0f172a;
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
    z-index: 60;
  }

  .chat-fab span {
    font-size: 26px;
  }

  /* ===============================
   CHAT POPUP
   =============================== */

  .chat-popup {
    position: fixed;
    right: 24px;
    bottom: 92px;
    width: 320px;
    max-height: 420px;
    background: white;
    border-radius: 20px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    z-index: 60;
  }

  /* Header */
  .chat-header {
    padding: 14px 16px;
    background: #0f172a;
    color: white;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .chat-header .left {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .chat-header p {
    font-size: 11px;
    opacity: 0.7;
  }

  .close-btn {
    background: none;
    border: none;
    color: white;
  }

  /* Body */
  .chat-body {
    flex: 1;
    padding: 16px;
    background: #f8fafc;
    overflow-y: auto;
    min-height: 17rem;
  }

  .chat-msg {
    max-width: 80%;
    padding: 10px 12px;
    border-radius: 12px;
    font-size: 14px;
  }

  .chat-msg.bot {
    background: white;
    color: #0f172a;
  }

  /* Input */
  .chat-input {
    display: flex;
    padding: 10px;
    border-top: 1px solid #e5e7eb;
    background: white;
  }

  .chat-input input {
    flex: 1;
    border: none;
    padding: 10px;
    font-size: 14px;
    background: #f8fafc;
    border-radius: 10px;
  }

  .chat-input button {
    margin-left: 8px;
    background: #0f172a;
    color: white;
    border-radius: 10px;
    padding: 0 12px;
  }

  /* ===============================
   MOBILE
   =============================== */

  @media (max-width: 640px) {
    .chat-popup {
      right: 12px;
      left: 12px;
      width: auto;
    }

    .chat-fab {
      right: 16px;
      bottom: 16px;
    }
  }

  /* ===============================
   CHAT MESSAGE STYLING PATCH
   =============================== */

  .chat-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  /* Base bubble */
  .chat-msg {
    max-width: 78%;
    padding: 10px 14px;
    border-radius: 14px;
    font-size: 13.5px;
    line-height: 1.4;
    word-wrap: break-word;
    animation: fadeInChat 0.15s ease-out;
  }

  /* ✅ USER MESSAGE (Right / Black) */
  .chat-msg.user {
    align-self: flex-end;
    background: #0f172a;
    color: white;
    border-bottom-right-radius: 6px;
  }

  /* ✅ AI / BOT MESSAGE (Left / White) */
  .chat-msg.bot {
    align-self: flex-start;
    background: white;
    color: #0f172a;
    border-bottom-left-radius: 6px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06);
  }

  /* Optional subtle entry animation */
  @keyframes fadeInChat {
    from {
      opacity: 0;
      transform: translateY(2px);
    }

    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* ===============================
   MOBILE POLISH
   =============================== */

  @media (max-width: 640px) {

    .chat-msg {
      max-width: 85%;
      font-size: 13px;
    }
  }

  .chat-msg.typing {
    background: white;
    color: #64748b;
    font-style: italic;
  }

  /* ============================= */
  /* APP.VUE MOBILE PATCH */
  /* ============================= */

  @media (max-width: 1024px) {
    .main-wrapper {
      width: 100%;
    }
  }

  /* ============================= */
  /* TABLET & MOBILE */
  /* ============================= */
  @media (max-width: 768px) {

    /* SIDEBAR FIX (SYNC WITH INDEX.HTML) */
    .sidebar {
      position: fixed;
      top: 0;
      left: -100%;
      height: 100%;
      width: 240px;
      background: white;
      z-index: 999;
      transition: 0.3s ease;
    }

    .sidebar.active {
      left: 0;
    }

    /* OVERLAY (VERY IMPORTANT UX) */
    .sidebar-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.4);
      z-index: 998;
    }

    /* TOPBAR */
    .topbar {
      height: 60px;
      padding: 0 14px;
    }

    .menu-toggle {
      display: flex;
    }

    /* HIDE EXTRA TEXT */
    .admin-details {
      display: none;
    }

    /* CONTENT */
    .viewport {
      padding: 14px;
    }

    /* LOGIN SCREEN */
    .login-body {
      padding: 20px;
    }

    /* CHAT */
    .chat-popup {
      right: 10px;
      left: 10px;
      bottom: 80px;
      width: auto;
      max-height: 70vh;
    }

    .chat-body {
      padding: 12px;
    }

    .chat-input input {
      font-size: 13px;
    }

    .chat-fab {
      width: 50px;
      height: 50px;
    }
  }

  /* ============================= */
  /* SMALL MOBILE */
  /* ============================= */
  @media (max-width: 480px) {

    .topbar {
      padding: 0 10px;
    }

    .viewport {
      padding: 12px;
    }

    .chat-msg {
      font-size: 12.5px;
      padding: 8px 10px;
    }
  }

  /* ============================= */
  /* TOPBAR ALIGNMENT FIX */
  /* ============================= */

  .topbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  /* LEFT SIDE (ICON + TITLE) */
  .topbar-left {
    display: flex;
    align-items: center;
    gap: 10px;
    /* control spacing here */
  }

  /* TITLE */
  .page-info h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
    color: #0F172A;
  }

  /* REMOVE EXTRA OFFSET */
  .page-info {
    margin-left: 0;
    /* important */
  }

  /* MENU ICON */
  .menu-toggle {
    display: flex;
    align-items: center;
    font-size: 22px;
    cursor: pointer;
  }
  /* OVERLAY */
.logout-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(15, 23, 42, 0.5);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

/* MODAL */
.logout-modal {
  background: #fff;
  padding: 30px;
  border-radius: 20px;
  width: 100%;
  max-width: 360px;
  text-align: center;
  box-shadow: 0 25px 50px rgba(0,0,0,0.15);
  animation: fadeIn 0.25s ease;
}

/* ICON */
.logout-icon {
  width: 60px;
  height: 60px;
  background: #FFF7ED;
  color: #2563eb;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 15px;
  font-size: 26px;
}

/* TEXT */
.logout-modal h3 {
  font-size: 18px;
  font-weight: 800;
  color: #0F172A;
}

.logout-modal p {
  font-size: 14px;
  color: #64748B;
  margin-top: 6px;
}

/* BUTTONS */
.logout-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.btn-cancel {
  flex: 1;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #E2E8F0;
  background: #fff;
  font-weight: 600;
  cursor: pointer;
}

.btn-logout {
  flex: 1;
  padding: 12px;
  border-radius: 12px;
  border: none;
  background: #2563eb;
  color: white;
  font-weight: 700;
  cursor: pointer;
}

/* ANIMATION */
@keyframes fadeIn {
  from {
    transform: translateY(10px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}
/* ============================= */
/* DESKTOP COLLAPSE */
/* ============================= */

.sidebar {
  width: 240px;
  transition: all 0.3s ease;
}

.sidebar.collapsed {
  width: 70px;
}

/* HIDE TEXT */
.sidebar.collapsed .nav-item span,
.sidebar.collapsed .nav-group-label {
  display: none;
}

/* CENTER ICON */
.sidebar.collapsed .nav-item {
  justify-content: center;
}

/* ICON SIZE */
.sidebar .nav-item i {
  font-size: 18px;
}
.sidebar.collapsed .nav-item .bx-chevron-down {
  display: none;
}
/* DEFAULT (EXPANDED) */
.logo-img-sm {
  display: none;
}

/* COLLAPSED MODE */
.sidebar.collapsed .logo-img {
  display: none;
}

.sidebar.collapsed .logo-img-sm {
  display: block;
  width: 2.7rem;
}
/* Sidebar full height layout */
.sidebar {
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* prevent full sidebar scroll */
}

/* Menu scroll container */
.sidebar-menu {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
}

/* Smooth scrollbar (optional but clean) */
.sidebar-menu::-webkit-scrollbar {
  width: 5px;
}

.sidebar-menu::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 10px;
}

/* Submenu (Masterdata dropdown) */
.submenu {
  padding-left: 12px;
}

/* IMPORTANT: prevent layout break */
.sidebar * {
  box-sizing: border-box;
}
</style>